<div class="active-topic-bar">
  <span class="topic-badge-icon">{{ getCategoryIcon(topic().primaryTopic) }}</span>
  <span class="topic-badge-text">{{ topic().problemSummary }}</span>
  <span class="topic-badge-severity" [style.background]="getSeverityColor(topic().severity)">
    {{ topic().severity }}
  </span>
  <button type="button" class="clear-topic-btn" (click)="clear.emit()">✕</button>
</div>
